import React from 'react';
import { Form } from 'semantic-ui-react';

function convertirANumero(texto: string) {
    const numero = parseInt(texto.replace(/[^0-9]/g, ''), 10);
    return isNaN(numero) ? 0 : numero;
}

function formatearMonto(monto: number) {
    return monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

interface DatosFormulario {
    readonly montoGasto: number;
    readonly responsableGasto: string;
    readonly motivoGasto: 'pago' | 'adelanto' | 'retiro' | 'otro' | 'sinEspecificar';
    readonly otroMotivoGasto?: string;
    readonly observacionesGasto: string;
}

interface FormularioGastosProps {
    listaDeResponsables: ReadonlyArray<{ id: string; nombre: string }>;
    alRegistrarGasto(datosFormulario: DatosFormulario): Promise<void>;
}

interface State extends DatosFormulario {
    cargando: boolean;
}

const stateInicial: State = {
    montoGasto: 0,
    responsableGasto: '',
    motivoGasto: 'pago',
    otroMotivoGasto: '',
    observacionesGasto: '',
    cargando: false,
};

class FormularioGastos extends React.Component<FormularioGastosProps, State> {
    public state: State = { ...stateInicial };

    public render() {
        const { alRegistrarGasto, listaDeResponsables } = this.props;
        const {
            montoGasto,
            responsableGasto,
            motivoGasto,
            otroMotivoGasto,
            observacionesGasto,
        } = this.state;

        return (
            <Form
                onSubmit={() => {
                    const { cargando: _, ...resto } = this.state;
                    this.setState({ cargando: true });
                    alRegistrarGasto(resto)
                        .then(() => {
                            this.setState(stateInicial);
                        })
                        .catch();
                }}
                loading={this.state.cargando}
            >
                <Form.Input
                    required
                    label='Monto'
                    placeholder='Ingresar monto...'
                    width={4}
                    value={formatearMonto(montoGasto)}
                    onChange={(_e, { value }) => {
                        this.actualizarState('montoGasto', convertirANumero(value));
                    }}
                />
                <Form.Select
                    required
                    label='Responsable'
                    placeholder='Nombre responsable...'
                    width={8}
                    value={responsableGasto}
                    options={listaDeResponsables.map(x => ({
                        key: x.id,
                        value: x.id,
                        text: x.nombre,
                    }))}
                    onChange={(_e, { value }) => {
                        this.actualizarState('responsableGasto', value as string);
                    }}
                />
                <Form.Group>
                    <Form.Select
                        required
                        label='Motivo'
                        placeholder='Seleccione...'
                        width={4}
                        options={[
                            { value: 'pago', text: 'Pago' },
                            { value: 'adelanto', text: 'Adelanto' },
                            { value: 'retiro', text: 'Retiro' },
                            { value: 'otro', text: 'Otro' },
                            { value: 'sinEspecificar', text: 'Sin especificar' },
                        ]}
                        value={motivoGasto}
                        onChange={(_e, { value }) => {
                            this.actualizarState('motivoGasto', value as string);
                        }}
                    />
                    <Form.Field required width={16} hidden={motivoGasto !== 'otro'}>
                        <Form.Input
                            label='Otro'
                            required={motivoGasto === 'otro'}
                            placeholder='Especificar...'
                            width={12}
                            disabled={motivoGasto === 'sinEspecificar'}
                            value={otroMotivoGasto}
                            onChange={(_e, { value }) => {
                                this.actualizarState('otroMotivoGasto', value);
                            }}
                        />
                    </Form.Field>
                </Form.Group>
                <Form.TextArea
                    label='Observaciones'
                    value={observacionesGasto}
                    onChange={(_e, { value }) => {
                        this.actualizarState('observacionesGasto', value as string);
                    }}
                />
                <Form.Button
                    type='submit'
                    content='Registrar gasto'
                    disabled={!this.camposSonValidos() || this.state.cargando}
                />
            </Form>
        );
    }

    private readonly actualizarState = (campo: string, valor: string | number) => {
        this.setState({ ...this.state, [campo]: valor });
    };

    private readonly camposSonValidos = () => {
        const { state } = this;
        if (state.montoGasto === 0 || isNaN(state.montoGasto)) {
            return false;
        }
        if (state.otroMotivoGasto === undefined) {
            return false;
        }
        if (state.motivoGasto === 'otro' && state.otroMotivoGasto.length === 0) {
            return false;
        }
        if (state.responsableGasto === '') {
            return false;
        }
        return true;
    };
}

export default FormularioGastos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/componentes/FormularioGastos.tsx